module.exports = __webpack_public_path__ + "media/theme/collection__itunes-bb9c50c7.png";